@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.passengers

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.web.dto.passengerprofilegroup.PassengerProfileGroupDto
import com.narbase.letsgo.web.models.PhoneNumberAvailabilityStatus

class ExtendedPassengerDto(
    val passenger: PassengerDto,
    val profileGroup: PassengerProfileGroupDto,
    val phoneNumbers: Array<PassengerPhoneNumberDto>
)

class PhoneNumberAvailabilityDto(
    @Suppress("NON_EXPORTABLE_TYPE") val availabilityStatus: DtoName<PhoneNumberAvailabilityStatus>,
    val unavailablePhoneNumber: PassengerPhoneNumberDto?,
    val phoneNumberOwner: ExtendedPassengerDto?
)